import React, { useEffect } from 'react';
import { toast } from 'react-toastify';
import { IAccessPoint } from '../../../types/location/location';
import {
  StyledContainerFooterSideBar,
  StyledContainerItems,
  StyledTitleSideBar
} from '../../../components/commons/SideBarComponents/sideBarComponentsStyles';
import { SideBarDeleteActionWithPopup } from '../../../components/commons/SideBarComponents/DeleteActionWithPopup/sideBarDeleteActionWithPopup';
import Strings from '../../../i18n';
import { useDeleteAccessPointsMutation } from '../../../services/locations/locationsService';

interface IAccessPointProps {
  selectedAccessPoint: IAccessPoint[];
  setSelectedAccessPoint: any;
  setOpenSideBar: (openSideBar: boolean) => void;
  reloadTable: () => void;
}
export const MultipleAccessPoint = ({
  selectedAccessPoint,
  setSelectedAccessPoint,
  setOpenSideBar,
  reloadTable
}: IAccessPointProps) => {
  const [deleteAcc, { isSuccess: isSuccessDelete }] =
    useDeleteAccessPointsMutation();

  const deleteAccessPoint = () => {
    const ids = selectedAccessPoint.reduce((acc: number[], event) => {
      return [...acc, event.locationAccessPointId];
    }, []);
    deleteAcc(ids);
  };

  useEffect(() => {
    if (isSuccessDelete) {
      setOpenSideBar(false);
      setSelectedAccessPoint([]);
      toast.success(Strings.accessPoints.deleteAccessPoint);
      reloadTable();
    }
  }, [isSuccessDelete]);

  return (
    <>
      {selectedAccessPoint && (
        <>
          <StyledContainerItems>
            <StyledTitleSideBar>
              {Strings.accessPoints.multipleSelectedAccessPoints}
            </StyledTitleSideBar>
            <SideBarDeleteActionWithPopup
              onDelete={() => deleteAccessPoint()}
              titleConfirmation={Strings.accessPoints.deleteMultipleAccessTitle}
              textConfirmation={Strings.common.thisActionIsIrreversible}
              textIcon={Strings.accessPoints.deleteAccess}
            />
          </StyledContainerItems>

          <StyledContainerFooterSideBar>
            <button
              type="button"
              className="btn-cancel"
              onClick={() => {
                setOpenSideBar(false);
                setSelectedAccessPoint([]);
              }}
            >
              {Strings.common.cancel}
            </button>
          </StyledContainerFooterSideBar>
        </>
      )}
      <div />
    </>
  );
};
